import { Check, Phone } from "lucide-react";
import { Reveal } from "./motion";
import { PRICING, BUSINESS } from "@/data/siteData";

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="bg-mist py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <p className="text-brand font-semibold text-sm tracking-wide uppercase">Transparent Pricing</p>
            <h2 className="font-display font-bold text-ink tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.1]">
              Upfront quotes for mobile service
            </h2>
            <p className="text-slate2 text-base sm:text-lg mt-4">
              Pricing depends on your vehicle and location. We confirm the service price and any travel fee before you book.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-5 lg:gap-6">
          {PRICING.map((p, i) => {
            const isQuote = true;
            const featured = i === 0;
            return (
              <Reveal key={p.name} delay={i * 0.08}>
                <div
                  data-testid={`pricing-card-${i}`}
                  className={`card-soft h-full p-8 flex flex-col ${featured ? "ring-2 ring-brand/60" : ""}`}
                >
                  {featured && (
                    <span className="self-start mb-4 rounded-full bg-brand text-white text-[11px] font-semibold px-3 py-1 tracking-wide uppercase">Most Popular</span>
                  )}
                  <h3 className="font-display font-semibold text-ink text-lg">{p.name}</h3>
                  <div className="mt-4 mb-1">
                    <span className={`font-display font-extrabold text-brand ${isQuote ? "text-3xl" : "text-5xl"}`}>{p.price}</span>
                  </div>
                  <p className="text-slate2 text-sm leading-relaxed flex-1">{p.note}</p>
                  {isQuote ? (
                    <a data-testid={`pricing-call-${i}`} href={BUSINESS.phoneHref} className="btn-accent rounded-full px-6 py-3 text-sm font-semibold mt-6 flex items-center justify-center gap-2">
                      <Phone size={16} /> Call for a Quote
                    </a>
                  ) : (
                    <button data-testid={`pricing-book-${i}`} onClick={go} className={`${featured ? "btn-accent" : "btn-outline"} rounded-full px-6 py-3 text-sm font-semibold mt-6`}>
                      Book Now
                    </button>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <p className="text-center text-slate2 text-sm mt-8 flex items-center justify-center gap-2 flex-wrap">
            <Check size={16} className="text-brand" /> Cash, Zelle & major credit cards accepted (card processing fee applies) · Dealer & fleet accounts invoiced
          </p>
        </Reveal>
      </div>
    </section>
  );
}
